<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editDevice" ref="editDeviceRef" label-width="75px">
          <el-form-item label="归属机构" class="addAdminForm">
            <Rsljigou :propsjigouid="editDevice.jigouid" :propsjigouname="editDevice.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="保修卡号" class="addAdminForm">
            <el-input type="textarea" v-model="editDevice.cardnumberlist" placeholder="请从Excel复制多行保修卡号进来"></el-input>
          </el-form-item>
          <el-form-item label="结果" class="addAdminForm">
            <el-input type="textarea" v-model="editDevice.result"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  data () {
    return {
      editDevice: {
        jigouid: '0',
        jigouname: '',
        cardnumberlist: '',
        result: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata) {
      this.editDevice.jigouid = '0'
      this.editDevice.jigouname = ''
      this.editDevice.cardnumberlist = ''
      this.editDevice.result = ''
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.EditDeviceJigouPlLiang()
    },
    changeRsljigou (vid, vname) {
      this.editDevice.jigouid = vid
      this.editDevice.jigouname = vname
    },
    EditDeviceJigouPlLiang: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.editDevice.jigouid,
        cardnumberlist: that.editDevice.cardnumberlist
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditDeviceJigouPlLiang, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          if (response.data.Code === 200) {
            that.editDevice.result = response.data.Result
          }
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
